import React from "react";
import homeStyle from "./styles";
import { Avatar, Box, Typography, Button, Link } from "@mui/material";

const FollowUs = (props) => {
  const data = [
    {
      name: "Discord",
      src: "/images/home/social/discord.svg",
      openNewTab: true,
      url: " https://discord.gg/qr2xB7HZRs",
    },
    {
      name: "Telegram",
      src: "/images/home/social/telegram.svg",
      openNewTab: true,
      url: "https://t.me/+6ldTYbzU1epmMmU9",
    },
    {
      name: "Twitter",
      src: "/images/home/social/twitter.svg",
      openNewTab: true,
      url: " https://twitter.com/FanTiger_com",
    },
    {
      name: "Medium",
      src: "/images/home/social/medium.svg",
      openNewTab: true,
      url: " https://medium.com/@fantiger",
    },
    {
      name: "YouTube",
      src: "/images/home/social/youtube.svg",
      openNewTab: true,
      url: " https://www.youtube.com/channel/UCIdKpJFO7wQls-MvJhLxtVw",
    },
    {
      name: "Instagram",
      src: "/images/home/social/instagram-reduced.png",
      openNewTab: true,
      url: " https://www.instagram.com/fantiger_com/",
    },
    {
      name: "Facebook",
      src: "/images/home/social/facebook.svg",
      openNewTab: true,
      url: "https://www.facebook.com/FanTiger.india/",
    },
  ];
  return (
    <Box sx={homeStyle.followUsSection}>
      <Box sx={homeStyle.followUsTitle}>
        <Typography sx={homeStyle.followUsTitleH1}>Follow Us</Typography>
      </Box>
      <Box sx={homeStyle.followUsIcons}>
        {data &&
          data?.length > 0 &&
          data.map((item, i) => (
            <Box key={i} style={{ cursor: "pointer" }}>
              <a
                // href={item?.url}
                onClick={() => window.open(item?.url)}
                // target="_blank"
                rel="noopener noreferrer"
              >
                <Box component="img" src={item?.src} alt="" />
                <Box
                  component="img"
                  sx={homeStyle.shadowBlur}
                  src={item?.src}
                  alt=""
                />
                <Typography
                  component="p"
                  style={{ color: "#fff" }}
                  sx={homeStyle.iconName}
                >
                  {item?.name}
                </Typography>
              </a>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default FollowUs;
